import { render, staticRenderFns } from "./list-menu.vue?vue&type=template&id=935ad52c"
import script from "./list-menu.vue?vue&type=script&lang=js"
export * from "./list-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports